module.exports = __webpack_public_path__ + "media/Video 127.7330631b.mp4";